const labels = ["Floor Plan", "Rooms", "Package", "Your Details"];

export default function Stepper({ step }) {
  return (
    <ol className="flex items-center gap-3 md:gap-5" data-testid="wizard-stepper">
      {labels.map((l, i) => (
        <li key={l} className="flex items-center gap-3 md:gap-5" data-testid={`wizard-step-${i + 1}`}>
          <span className={`flex items-center gap-2 text-xs md:text-sm transition-colors ${i <= step ? "text-brand-ink" : "text-brand-muted-light"}`}>
            <span className={`font-mono-num w-7 h-7 rounded-full grid place-items-center text-xs border transition-colors ${i < step ? "bg-brand-accent border-brand-accent text-white" : i === step ? "border-brand-ink" : "border-brand-line"}`}>{i + 1}</span>
            <span className="hidden sm:inline">{l}</span>
          </span>
          {i < labels.length - 1 && <span className="w-6 md:w-12 h-px bg-brand-line" />}
        </li>
      ))}
    </ol>
  );
}
